<style scoped lang="scss">
.status-name {
    /*font-weight: bold;*/
}
</style>

<template>
    <tr>
        <td>
            {{ application.id }}
        </td>
        <td>{{ application.program.program_name }}</td>
        <td>
            <span class="status-name">{{ application.status.program_application_status_name}}</span>
        </td>
        <td>
            <span >{{application.status.description}}</span>
        </td>
        <td v-if="!application.prequal_answers">
            <a href="javascript:;" @click="$emit('prequalify')" class="uk-button uk-width-1-1 uk-margin-bottom uk-primary uk-button-large">Prequalify</a>
        </td>
        <td v-else>
            <router-link :to="'/application/'+application.id" v-if="application.status.id != 1 && application.status.allow_household_edit && application.status.id !== 15" class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom">Edit Application</router-link>
            <router-link :to="'/application/'+application.id" v-if="application.status.id === 1" class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom">Begin Application</router-link>
            <router-link :to="'/'" v-if="application.status.id === 15" class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom">Waitlisted</router-link>
            <a :href="'/hope/prequal-letter/'+application.id" target="_blank" v-if="application.status.show_prequal_letter" class="uk-button uk-button-primary">PRE-QUALIFICATION LETTER</a>
            <a :href="'/hope/payment-letter/'+application.id" target="_blank" v-if="application.status.show_payment_letter" class="uk-button uk-button-primary">PAYMENT LETTER</a>
        </td>
    </tr>
</template>

<script>
    export default {
        name: "ApplicationRow",
        props: ['application'],
    }
</script>
